import { useEffect, useState } from 'react';

const KEY = 'npi-theme';
const EVENT = 'npi-theme-change';

export const getThemeChoice = () => {
  try { return localStorage.getItem(KEY) || 'system'; } catch { return 'system'; }
};

// choice: 'system' | 'light' | 'dark'
export const setThemeChoice = (choice) => {
  const root = document.documentElement;
  if (choice === 'light' || choice === 'dark') root.setAttribute('data-theme', choice);
  else root.removeAttribute('data-theme');
  try { localStorage.setItem(KEY, choice); } catch { /* private mode: still applies for this visit */ }
  window.dispatchEvent(new Event(EVENT));
};

const systemQuery = () => window.matchMedia('(prefers-color-scheme: dark)');

export const resolvedTheme = () => {
  const choice = getThemeChoice();
  if (choice !== 'system') return choice;
  return systemQuery().matches ? 'dark' : 'light';
};

// Re-renders when the user changes the switch or the OS setting changes.
export const useTheme = () => {
  const [state, setState] = useState(() => ({ choice: getThemeChoice(), mode: resolvedTheme() }));
  useEffect(() => {
    const update = () => setState({ choice: getThemeChoice(), mode: resolvedTheme() });
    const mq = systemQuery();
    mq.addEventListener('change', update);
    window.addEventListener(EVENT, update);
    return () => {
      mq.removeEventListener('change', update);
      window.removeEventListener(EVENT, update);
    };
  }, []);
  return { ...state, setChoice: setThemeChoice };
};
